import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Layout from './components/Layout';
import RoleGuard from './components/RoleGuard';
import DashboardPage from './pages/DashboardPage';
//import PlaceholderPage from './pages/PlaceholderPage';
import UsersPage from './pages/UsersPage';
import ClientesPage from './pages/ClientesPage';
import ObraPage from './pages/ObraPage';
import EmpresaPage from './pages/EmpresaPage';
import ContatosPage from './pages/ContatosPage';
import CaminhoesPage from './pages/CaminhoesPage';
import ConcretagensPage from './pages/ConcretagensPage';
import GestaoConcretagemPage from './pages/GestaoConcretagemPage';
import MoldadoresPage from './pages/MoldadoresPage';
import ConcreteirasPage from './pages/ConcreteirasPage';
import ResultadosCorposProvaPage from './pages/ResultadosCorposProvaPage';
import RevisaoResultadosPage from './pages/RevisaoResultadosPage';
import FichaRupturaPage from './pages/FichaRupturaPage';
import MedicaoRelatorioPage from './pages/MedicaoRelatorioPage';
import ResultadosSequencialPage from './pages/ResultadosSequencialPage';
import RelatorioCaminhao from './pages/RelatorioCaminhao';
import CadastrosTecnicosPage from './pages/CadastrosTecnicosPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SignUpPage from './pages/SignUpPage';
import VerificarEmailPage from './pages/VerificarEmailPage';
import DevPdfPreviewPage from './pages/DevPdfPreviewPage';
import DevPdfPreviewCaminhaoPage from './pages/DevPdfPreviewCaminhaoPage';
import DevPdfPreviewFichaRupturaPage from './pages/DevPdfPreviewFichaRupturaPage';
import DevPdfPreviewMedicaoPage from './pages/DevPdfPreviewMedicaoPage';

function App() {
  // Impede que o scroll do mouse altere o valor de inputs numericos focados (global)
  useEffect(() => {
    const handleWheel = (event) => {
      const el = document.activeElement;
      if (el && el.tagName === 'INPUT' && el.type === 'number' && el === event.target) {
        el.blur();
      }
    };
    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
      <Route path="/cadastro" element={<SignUpPage />} />
      <Route path="/verificar-email" element={<VerificarEmailPage />} />
      <Route
        path="/app"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="usuarios" element={<UsersPage />} />
        <Route
          path="clientes"
          element={
            <RoleGuard allowedRoles={['admin']}>
              <ClientesPage />
            </RoleGuard>
          }
        />
        <Route path="empresas" element={<EmpresaPage />} />
        <Route path="contatos" element={<ContatosPage />} />
        <Route path="obras" element={<ObraPage />} />
        <Route path="concretagens" element={<ConcretagensPage />} />
        <Route path="gestao-concretagem" element={<GestaoConcretagemPage />} />
        <Route path="moldadores" element={<MoldadoresPage />} />
        <Route path="caminhoes" element={<CaminhoesPage />} />
        <Route path="testes-slump" element={<Navigate to="/app" replace />} />
        <Route path="concreteiras" element={<ConcreteirasPage />} />
        <Route path="corpos-prova" element={<Navigate to="/app" replace />} />
        <Route path="resultados-corpos-prova" element={<ResultadosCorposProvaPage />} />
        <Route path="revisao-resultados" element={<RevisaoResultadosPage />} />
        <Route path="ficha-ruptura"element={<FichaRupturaPage />} />
        <Route path="resultados-sequencial" element={<ResultadosSequencialPage />} />
        <Route path="relatorio-caminhao" element={<RelatorioCaminhao />} />
        <Route path="medicao-moldagem" element={<MedicaoRelatorioPage tipo="moldagem" />} />
        <Route path="medicao-ruptura" element={<MedicaoRelatorioPage tipo="ruptura" />} />
        <Route path="dev-pdf-preview" element={<DevPdfPreviewPage />} />
        <Route path="dev-pdf-preview-caminhao" element={<DevPdfPreviewCaminhaoPage />} />
        <Route path="dev-pdf-preview-ficha-ruptura" element={<DevPdfPreviewFichaRupturaPage />} />
        <Route path="dev-pdf-preview-medicao" element={<DevPdfPreviewMedicaoPage />} />
        <Route path="dev-pdf-preview-medicao-ruptura" element={<DevPdfPreviewMedicaoPage tipoInicial="ruptura" />} />
        <Route path="cadastros-tecnicos" element={<CadastrosTecnicosPage />} />
        {/* Rotas antigas dos cadastros que foram movidos para Cadastros técnicos. */}
        <Route path="tipos-carga" element={<Navigate to="/app/cadastros-tecnicos?aba=carga" replace />} />
        <Route path="tipos-corpo-prova" element={<Navigate to="/app/cadastros-tecnicos?aba=corpo-prova" replace />} />
        <Route path="tipos-cimento" element={<Navigate to="/app/cadastros-tecnicos?aba=cimento" replace />} />
        <Route path="prensas" element={<Navigate to="/app/cadastros-tecnicos?aba=prensa" replace />} />
        <Route path="calibracoes-prensa" element={<Navigate to="/app" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;